import { render, staticRenderFns } from "./FaultComparisonPlot.vue?vue&type=template&id=0bd7bbd2&scoped=true&"
import script from "./FaultComparisonPlot.vue?vue&type=script&lang=js&"
export * from "./FaultComparisonPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7bbd2",
  null
  
)

export default component.exports